import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass, Home, LifeBuoy, Trophy } from "lucide-react";
import { ErrorScreen } from "@/components/system/ErrorScreen";
import { OPEN_PATHWAY_LABEL, getOpenPathwayHref, OPEN_PATHWAY_SLUG } from "@/config/launchCatalog";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.title = "Page not found | GG Life";
  }, []);

  return (
    <ErrorScreen
      code="404"
      eyebrow="Off the map"
      title="This page isn't in the rotation"
      description="The page you're looking for doesn't exist, moved, or was retired. Your progress is untouched — jump back into a pathway below."
      actions={
        <>
          <Button
            size="lg"
            onClick={() => navigate("/")}
            className="min-h-12 w-full gap-2 sm:w-auto"
          >
            <Home className="h-5 w-5" />
            Back to homepage
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => navigate("/learn")}
            className="min-h-12 w-full gap-2 sm:w-auto"
          >
            <Compass className="h-5 w-5" />
            Browse pathways
          </Button>
        </>
      }
      links={[
        {
          label: OPEN_PATHWAY_LABEL,
          description: "Start with a free preview module",
          href: getOpenPathwayHref(OPEN_PATHWAY_SLUG),
          icon: <Trophy className="h-4 w-4" />,
        },
        {
          label: "Learn hub",
          description: "Search the full pathway catalog",
          href: "/learn",
          icon: <Compass className="h-4 w-4" />,
        },
        {
          label: "FAQ",
          description: "How pathways and certificates work",
          href: "/faq",
          icon: <LifeBuoy className="h-4 w-4" />,
        },
        {
          label: "Trust & support",
          description: "Safety, privacy and how to reach us",
          href: "/trust",
          icon: <LifeBuoy className="h-4 w-4" />,
        },

      ]}
      detail={
        <p className="text-center text-xs font-mono text-muted-foreground">
          Requested path: {location.pathname}
        </p>
      }
    />
  );
};

export default NotFound;
